export default __webpack_public_path__ + "static/media/icon-Growyx-workspace.27b8a36c.svg";